// components/LinkedDecisionsList.tsx

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import { useApi } from '../../utils/useApi';
import { toDE } from '../../utils/utils';

type LinkedDecision = {
  id: number;
  file_number?: string | null;
  name?: string | null;
  authority?: string | null;
  decision_date?: string | null;
  subject?: string | null;
};

type Props = {
  lawPartId: number;
};

const LinkedDecisionsList = ({ lawPartId }: Props) => {
  const { apiFetch } = useApi();
  const navigate = useNavigate();

  const [decisions, setDecisions] = useState<LinkedDecision[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!lawPartId) return;

    setLoading(true);
    setError('');

    apiFetch(`/api/decisions/linked/law_part/${lawPartId}`)
      .then(setDecisions)
      .catch(() => setError('Verknüpfte Bescheide konnten nicht geladen werden.'))
      .finally(() => setLoading(false));
  }, [apiFetch, lawPartId]);

  if (loading) return <Spinner animation="border" size="sm" />;

  if (error) return <Alert variant="danger">{error}</Alert>;

  if (decisions.length === 0) {
    return <Alert variant="secondary">Keine verknüpften Bescheide vorhanden.</Alert>;
  }

  return (
    <Table hover size="sm" className="mb-0">
      <thead>
        <tr>
          <th>Behörde</th>
          <th>Ausstellungsdatum</th>
          <th>Aktenzeichen</th>
          <th>Thematik</th>
          <th>Inhalt</th>
        </tr>
      </thead>
      <tbody>
        {decisions.map((decision) => (
          <tr
            key={decision.id}
            role="button"
            onClick={() => navigate(`/decisions/${decision.id}`)}
          >
            <td>{decision.authority || '-'}</td>
            <td>{decision.decision_date ? toDE(decision.decision_date) : '-'}</td>
            <td>{decision.file_number || '-'}</td>
            <td>{decision.name || '-'}</td>
            <td>{decision.subject || '-'}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default LinkedDecisionsList;